"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var ItemId_1 = __importDefault(require("@features/ItemCommon/components/fields/ItemDetails/ItemId"));
var ItemDates_1 = __importDefault(require("@features/ItemCommon/components/fields/ItemDetails/ItemDates"));
var ItemHistory_1 = __importDefault(require("@features/ItemCommon/components/fields/ItemDetails/ItemHistory"));
var RulesAndHistoryModal_1 = __importStar(require("src/react-app/features/ItemCommon/components/RulesAndHistoryModal"));
var useRulesAndHistoryModal_1 = require("@features/ItemCommon/components/RulesAndHistoryModal/useRulesAndHistoryModal");
var ItemMatchedRules_1 = __importDefault(require("@features/ItemCommon/components/fields/ItemDetails/ItemMatchedRules"));
var Duplicates_1 = __importDefault(require("@features/ItemCommon/components/fields/ItemDetails/Duplicates/Duplicates"));
var AdditionalInformationItem_1 = require("@features/ItemCommon/components/common/AdditionalInformationItem");
function ItemDetails(_a) {
    var _b, _c;
    var job = _a.job, domain = _a.domain, angularJsDependencies = _a.angularJsDependencies, templateIndex = _a.templateIndex, automationListsPermission = _a.automationListsPermission;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _d = (0, useRulesAndHistoryModal_1.useRulesAndHistoryModal)(job), selectedJob = _d.selectedJob, setSelectedJob = _d.setSelectedJob, isOpen = _d.isOpen, setIsOpen = _d.setIsOpen, selectedTab = _d.selectedTab, setSelectedTab = _d.setSelectedTab, minDate = _d.minDate, historyLength = _d.historyLength, numberOfDecisions = _d.numberOfDecisions, currentStatus = _d.currentStatus;
    if (templateIndex < 0) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "eva-job-other-information-section", style: { order: templateIndex } },
        react_1.default.createElement("h4", null, t('ITEM.ITEM_DETAILS')),
        react_1.default.createElement(ItemId_1.default, { job: job, angularJsDependencies: angularJsDependencies, classOverride: AdditionalInformationItem_1.defaultClassOverrideForItemDetail, automationListsPermission: automationListsPermission }),
        react_1.default.createElement(ItemDates_1.default, { job: job, domain: domain }),
        react_1.default.createElement(Duplicates_1.default, { job: job, angularJsDependencies: angularJsDependencies }),
        react_1.default.createElement(ItemHistory_1.default, { historyLength: historyLength, numberOfDecisions: numberOfDecisions, currentStatus: currentStatus, openModal: function () {
                setSelectedTab(RulesAndHistoryModal_1.TAB_HISTORY);
                setIsOpen(true);
                setSelectedJob(job);
            }, overrideClasses: {
                wrapper: 'item-detail-field',
                label: 'item-detail-field__label',
                link: 'item-detail-field__value-link-internal',
            } }),
        (((_c = (_b = job === null || job === void 0 ? void 0 : job.ad) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.processingResults) || []).length > 0 && (react_1.default.createElement(ItemMatchedRules_1.default, { job: job, openModal: function () {
                setSelectedTab(RulesAndHistoryModal_1.TAB_MATCHED_RULES);
                setIsOpen(true);
                setSelectedJob(job);
            }, overrideClasses: {
                wrapper: 'item-detail-field',
                label: 'item-detail-field__label',
                link: 'item-detail-field__value-link-internal',
            } })),
        minDate && (react_1.default.createElement(RulesAndHistoryModal_1.default, { selectedTab: selectedTab, setSelectedTab: setSelectedTab, selectedJob: selectedJob, isOpen: isOpen, setIsOpen: setIsOpen, angularJsDependencies: angularJsDependencies, minDate: minDate }))));
}
exports.default = ItemDetails;
